<template>
  <div class="preview">
    <el-image
      class="case-banner"
      fit="cover"
      :src="caseData.cover && caseData.cover.originalUrl"
      ><div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <div v-if="user" class="case-content">
      <!-- 用户信息 -->
      <div class="case-user" v-if="user.name">
        <img
          class="case-user-avatar"
          v-if="user.avatar"
          :src="user.avatar"
          alt
        />
        <div class="case-user-info">
          <p class="case-user-name">{{ user.name }}</p>
          <p class="case-user-post">{{ user.position }}</p>
        </div>
      </div>

      <!-- title -->
      <h2 class="case-title">{{ caseData.title }}</h2>

      <!-- 标签 -->
      <div v-if="caseData.lightspot">
        <el-tag v-if="caseData.lightspot.celebrity" class="tag" type="warning" size="small"
          ><svg-icon iconClass="star-beacon" class="star-icon"></svg-icon>{{ caseData.lightspot.celebrity }}</el-tag
        >
        <el-tag v-if="caseData.lightspot.community" class="tag" type="warning" size="small"><svg-icon iconClass="star-beacon" class="star-icon"></svg-icon>{{
          caseData.lightspot.community
        }}</el-tag>
        <el-tag
          class="tag"
          type="warning"
          size="small"
          v-for="item in caseData.lightspot.awards"
          :key="item"
          ><svg-icon iconClass="star-beacon" class="star-icon"></svg-icon>{{ item }}</el-tag
        >
        <el-tag
          class="tag"
          type="warning"
          size="small"
          v-for="item in caseData.lightspot.international"
          :key="item"
          ><svg-icon iconClass="star-beacon" class="star-icon"></svg-icon>{{ item }}</el-tag
        >
        <el-tag
          class="tag"
          type="warning"
          size="small"
          v-for="item in caseData.lightspot.reports"
          :key="item"
          ><svg-icon iconClass="star-beacon" class="star-icon"></svg-icon>{{ item }}</el-tag
        >
        <el-tag
          class="tag"
          type="warning"
          size="small"
          v-for="item in caseData.lightspot.special"
          :key="item"
          ><svg-icon iconClass="star-beacon" class="star-icon"></svg-icon>{{ item }}</el-tag
        >
      </div>
      <!-- 案例信息 -->
      <section v-if="caseData.info" class="section-wrapper">
        <h2 class="section-title">案例信息</h2>
        <div class="case-info">
          <span>
            <p>户型</p>
            <p>{{ caseData.info.houseType || "-" }}</p>
          </span>
          <span>
            <p>风格</p>
            <p>{{ caseData.info.style || "-" }}</p>
          </span>
          <span>
            <p>面积</p>
            <p>{{ caseData.info.area || "-" }}m²</p>
          </span>
          <span>
            <p>造价</p>
            <p>{{ caseData.info.cost || "-" }}万</p>
          </span>
          <span>
            <p>位置</p>
            <p>{{ caseData.info.city[1] || "-" }}</p>
          </span>
        </div>
      </section>

      <!-- 设计理念 -->
      <section v-if="caseData.designConcept" class="section-wrapper">
        <h2 class="section-title">设计理念</h2>
        <p>{{ caseData.designConcept }}</p>
      </section>

      <!-- 案例展示 -->
      <template v-if="caseData.type === 3">
        <section
          class="section-wrapper"
          v-for="aragraph in caseData.paragraphs"
          :key="aragraph.paragraphId"
        >
          <h2 v-if="aragraph.materials.length" class="section-title">
            {{ aragraph.title }}
          </h2>
          <div
            class="case-item"
            :key="material._id"
            v-for="material in aragraph.materials"
          >
            <img
              v-if="material.mediaType == 1"
              class="case-img"
              :src="material.cover"
              alt
            />
            <div v-else-if="material.mediaType == 3" class="case-desc">
              {{ material.content }}
            </div>
            <video
              v-else-if="material.mediaType == 2"
              width="100%"
              controls
              :src="material.videoUrl"
            ></video>
            <h2 v-else-if="material.mediaType == 4" class="section-title">
              {{ material.content }}
            </h2>
            <div v-if="material.content" class="case-desc">
              {{ material.content }}
            </div>
          </div>
        </section>
      </template>
      <template v-if="caseData.type === 4">
        <section class="section-wrapper">
          <div
            class="case-item"
            :key="material._id"
            v-for="material in caseData.materials"
          >
            <img
              v-if="material.mediaType == 1"
              class="case-img"
              :src="material.cover"
              alt
            />
            <div v-else-if="material.mediaType == 3" class="case-desc">
              {{ material.content }}
            </div>
            <video
              v-else-if="material.mediaType == 2"
              width="100%"
              controls
              :src="material.videoUrl"
            ></video>
            <h2 v-else-if="material.mediaType == 4" class="section-title">
              {{ material.content }}
            </h2>
          </div>
        </section>
      </template>

      <!-- 结语 -->
      <section v-if="caseData.conclusion" class="section-wrapper">
        <h2 class="section-title">结语</h2>
        <p>{{ caseData.conclusion }}</p>
      </section>
    </div>
  </div>
</template>

<script>
import SvgIcon from '../SvgIcon.vue';
export default {
  components: { SvgIcon },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    caseData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss">
.preview {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 0.53333rem 0.64rem 0;
  scroll-behavior: smooth;
}
.tag {
  margin: 3px;
}
.star-icon{
  margin-right: 5px;
}
.case-banner {
  width: 100%;
  height: 274px;
  background: #f5f5f5;
  display: block;
  position: relative;
}
.image-slot {
  position: absolute;
  left: 0;
  top: -20px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.case-content {
  background: #fff;
  margin-top: -47px;
  position: relative;
  z-index: 1;
  border-radius: 10px 10px 0 0;
  padding: 20px 16px;
}

.case-title {
  font-size: 20px;
  line-height: 1.5;
  color: #222222;
  font-weight: 600;
}

.case-user {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 9px;
  margin-bottom: 20px;
  .case-user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 12px;
  }
  .case-user-name {
    color: #222222;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
  }
  .case-user-post {
    color: #999999;
    font-size: 12px;
    line-height: 17px;
    margin-top: 1px;
  }
}

.section-wrapper {
  margin-top: 20px;
  .section-title {
    color: #222222;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 14px;
  }
}

.case-item {
  margin-bottom: 30px;
  .case-img {
    width: 100%;
    display: block;
  }
  .case-desc {
    color: #222222;
    font-size: 14px;
    line-height: 20px;
    margin-top: 15px;
  }
}

.case-info {
  background: #f5f5f5;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  span {
    :first-child {
      color: #999999;
    }
  }
  p {
    text-align: center;
  }
}
</style>
